// sections/DetailNotesSection.tsx

import { useReceivableDetail } from "../../hooks/useReceivableDetail";

const DetailNotesSection = () => {
  const { detail } = useReceivableDetail();

  if (!detail) return null;

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Observaciones
      </h4>

      {!detail.notes ? (
        <div
          className="
            rounded-lg
            border border-dashed border-gray
            bg-gray-2
            p-5
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="text-sm text-body dark:text-bodydark">
            No hay observaciones registradas para esta cuenta por cobrar.
          </p>
        </div>
      ) : (
        <div
          className="
            rounded-lg
            border border-primary/20
            bg-primary/5
            p-5
            dark:border-primary/30
            dark:bg-primary/10
          "
        >
          <p className="leading-relaxed text-black dark:text-white">
            {detail.notes}
          </p>
        </div>
      )}
    </section>
  );
};

export default DetailNotesSection;